import { gql } from "@grandvisionhq/graphql";
const estimatedDelivery = gql`
  fragment EstimatedDeliveryFragment on EstimatedDelivery {
    deliveryDate
    shippingDate
    shippingMethodDescription {
      locale
      value
      __typename
    }
    __typename
  }
`;
export {
  estimatedDelivery
};
//# sourceMappingURL=estimated-delivery.js.map
